import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { siteInfo } from "@/mocks/site-info";

export default function HomeSidebar() {
  const popularArticles = articles
    .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime())
    .slice(0, 5);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                热门推荐
              </h2>
              <Link
                to="/category/reviews"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 cursor-pointer"
              >
                查看全部
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {popularArticles.slice(0, 4).map((article) => (
                <ArticleCard key={article.slug} article={article} variant="default" />
              ))}
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-background-100 border border-background-200/70 rounded-lg p-5">
              <h3 className="text-base font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                热门分类
              </h3>
              <div className="space-y-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex items-center justify-between p-3 rounded-md hover:bg-background-50 transition-colors cursor-pointer no-underline"
                  >
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                        <i className={`${cat.icon} text-sm`}></i>
                      </div>
                      <span className="text-sm font-medium text-foreground-700">{cat.name}</span>
                    </div>
                    <span className="text-xs text-foreground-400">
                      {articles.filter((a) => a.category === cat.slug).length} 篇
                    </span>
                  </Link>
                ))}
              </div>
            </div>

            <div className="bg-background-100 border border-background-200/70 rounded-lg p-5">
              <h3 className="text-base font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                关于本站
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {siteInfo.description.length > 120
                  ? siteInfo.description.slice(0, 120) + "..."
                  : siteInfo.description}
              </p>
              <Link
                to="/about"
                className="inline-flex items-center gap-1 mt-3 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer"
              >
                了解更多
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}